<template>
  <div>
    <div>
      <div class="details-banner" v-if="!bannerImg"></div>
      <a :href="!!bannerPath && bannerPath">
        <img :src="bannerImg" style="width: 100%;margin-top: 64px" v-if='sourceType === "img" && bannerImg' />
        <video id="" autoplay muted loop preload="auto"
          style="z-index: 200; width: 100%; height: auto;;margin-top: 64px" v-if='sourceType === "video" && video'>
          <source type="video/mp4" :src="video" />
        </video>
      </a>
    </div>
    <div class="solution-container">
      <div class="solution-head">
        <el-row>
          <el-col :xs="8" :md="3" :lg="2" v-for="(item, index) in list" :key="index">
            <span class="solution-head-title" :class="{ active: active == index }"
              @click="handlePositionClock(index)">{{ item.dictLabel }}</span>
          </el-col>
        </el-row>

      </div>

      <div class="solution-contant">
        <div v-for="(item, index) in list" :key="index">
          <div :id="`id${index}`" style="height: 64px"></div>
          <div class="solution-contant-title">
            <span></span>
            <span>{{ item.dictLabel }}</span>
          </div>
          <el-row :gutter="50">
            <el-col v-for="(child, childIndex) in item.serviceList" :key="childIndex" :xs="24" :md="8" :lg="6"
              style="margin-bottom: 15px">
              <el-card :body-style="{ padding: '0px', cursor: 'pointer' }" shadow="hover">
                <div @click="handleDetailsClick(child)">
                  <img :src="child.schemeCover" style="width: 100%" />
                  <div class="card-text-title">{{ child.solutionTitle }}</div>
                  <div class="card-text-desc">{{ child.schemeIntroduction }}</div>
                  <div class="card-text-icon">
                    <i class="el-icon-right"></i>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listSolutionAll, listBanner } from '@/api'
export default {
  name: "Solution",
  metaInfo: {
    title: 'Eiiplat环境产业互联网平台解决方案，环卫智能化解决方案，环保智能化解决方案，大平台',
    meta: [
      { name: 'description', content: '青岛国真智慧Eiiplat环境产业物联网平台是国内首家环境产业工业互联网平台。提供环卫一体化智能解决方案，环境产业平台解决方案，智能施工解决方案，智能设计解决方案，智能收运解决方案，智能供应解决方案，智能管控解决方案，农村厕改智能管护系统解决方案，餐厨垃圾智能收运解决方案，餐厨垃圾施工管理系统。 、机制管理、财务管理、OKR管理八大应用，赋能行业转型升级。利用资金流驱动废弃物的循环流动，优化过程数据提高效率，对废弃物全生命周期追溯，为客户提高生产效率和降低运营成本提供持续的解决方案。' },
      { name: 'keywords', content: '环卫一体化智能解决方案，环境产业平台解决方案，智能施工解决方案，智能设计解决方案，智能收运解决方案，智能供应解决方案，智能管控解决方案，农村厕改智能管护系统解决方案，餐厨垃圾智能收运解决方案，餐厨垃圾施工管理系统。' },
    ],
  },
  data () {
    return {
      active: 0,
      list: [],
      sourceType: 'img',
      bannerImg: '',
      video: '',
      bannerPath: ''
    }
  },
  created () {
    this.getList()
    // 获取banner数据
    this.getBanner()
  },
  methods: {
    async getBanner () {
      const res = await listBanner({ bannerPosition: 'JJFA_BANNER', useFlag: '1' })

      const data = res.rows.find(v => (v.bannerImg && v.sourceType == 'img') || (v.video && v.sourceType == 'video'))
      if (!data) return
      this.sourceType = data.sourceType
      this.bannerImg = data.bannerImg
      this.video = data.video
      this.bannerPath = data.link
    },
    async getList () {
      const res = await listSolutionAll({ useFlag: '1' })
      this.list = res.data
    },
    handlePositionClock (index) {
      this.active = index
      this.$el.querySelector(`#id${index}`).scrollIntoView({
        behavior: 'smooth',  // 平滑过渡
        block: 'start'
      })
    },
    handleDetailsClick (item) {
      this.$router.push({ path: 'SolutionDetails', query: { id: item.id, index: 2 } })
      // console.log(item);
      // if (item.path.length != 0) {
      //   this.$router.push({ path: item.path, query: { name: item.name, index: 2 } })
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.solution-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  .solution-head {
    width: 75%;
    margin-top: 50px;

    .solution-head-title {
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      cursor: pointer;
    }

    .active {
      color: #E50009;
    }
  }

  .solution-contant {
    width: 75%;

    .solution-contant-title {
      height: 45px;
      margin-bottom: 20px;
      font-weight: 500;
      color: #000000;

      :first-child {
        display: inline-block;
        width: 3px;
        height: 20px;
        background: #E50009;
        margin-right: 5px;
      }

      span {
        font-size: 32px;
      }
    }


    .card-text-title {
      width: 80%;
      font-size: 16px;
      font-weight: 500;
      color: #131415;
      margin-left: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .card-text-desc {
      width: 80%;
      height: 65px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(19, 20, 21, 0.70);
      margin: 10px;
      word-break: break-all;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }

    .card-text-icon {
      margin-left: 10px;
      margin-bottom: 10px;
      color: #E50009;
      cursor: pointer;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/SolutionBakOld.vue